import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

export function PDFGenerator(title, bodyContent) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs
    
    const header = [{ 
        text: `${title}`,
        alignment: 'left',
        fontSize: 12,
        margin: [ 40, 10, 0, 20 ],
    }]

    const body = []

    function Footer(currentPage, pageCount) {
      return [{
          text: currentPage.toString() + '/' + pageCount,
          alignment: 'center',
          fontSize: 8,
        }]
    }

    body.push(bodyContent.tableHeader)
    bodyContent.lines.map(line => body.push(line))
    
    const content = {
      layout: 'noBorders',
      table: {
        heights: function(_) {
          return 20
        },
        widths: bodyContent.widths,
        headerRows: 1,
        body
      },
    }

    const docDefinitions = {
      pageSize: 'A4',

      header: [header],
      content: [content],
      footer: Footer,
     
      styles: {
        header: {
          fontSize: 15,
          color: '#FFF',
          fillColor: '#7A05A7',
          bold: true, 
          alignment: 'center',
          margin: 4
        },
        line: {
          alignment: 'center',
          fontSize: 10, 
          margin: 4,
          fillColor: "#F0F1F5",
          bold: true, 
          color: '#535354',
        },
        lineGray: {
          alignment: 'center',
          fontSize: 10, 
          margin: 4,
          fillColor: "#DDDDDD",
          bold: true, 
          color: '#535354',
        },
        total: {
          alignment: 'center',
          fontSize: 11, 
          margin: 4,
          fillColor: "#AAA",
          bold: true, 
          color: '#FFF',
        }
      }
    }

    pdfMake.createPdf(docDefinitions).download(`${title}`)
  }